export * as CreateAnimal from './CreateAnimal'
export * as DeleteAnimal from './DeleteAnimal'
export * as UpdateAnimal from './UpdateAnimal'
